import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import Link from "@mui/material/Link";
import SvgIcon from "@mui/material/SvgIcon";

import {featureInterface} from "../../../../interfaces/featureInterface";
import {GroheDownloadIcon} from "../../../common/icons";
import {isIOSDevice} from "../../../../misc/helpers";
import {getDbFeatureProperty} from "../../lookNavigation/lookFunctions2";


const ShopFeatureDownloads = (props) => {

  const {feature} = props;

  if (!feature.dbFeature[getDbFeatureProperty("lixilQRCode")]) {
    return null
  }

  const threeDSrc = feature.dbFeature[getDbFeatureProperty("lixilAR3DUrls")] ? feature.dbFeature[getDbFeatureProperty("lixilAR3DUrls")].map(src => {
    src = src.replace("s3.amazonaws.com/qc-lixil-3dfiles", "dv84u4f1bblk2.cloudfront.net");
    return src
  }) : [];
  let glb = threeDSrc.find(url => url.includes(".glb"));
  // let usdz = threeDSrc.find(url => url.includes(".usdz"));
  // let hdr = threeDSrc.find(url => url.includes(".hdr"));

  return (
    <div className="shop-feature__description">
      <h3 className="shop-feature__sub-title">
        <FormattedMessage id="shop.feature.downloads"/>
      </h3>
      <div className="shop-feature__newline">
        <Link className="shop-feature__link" target={"_blank"} href={feature.dbFeature[getDbFeatureProperty("lixilQRCode")]}>
          <SvgIcon>
            <GroheDownloadIcon/>
          </SvgIcon>
          <span className="shop-feature__link-text">
            <FormattedMessage id="shop.feature.arqrcode"/>
          </span>
        </Link>
      </div>
      {glb && isIOSDevice() ? (
        <div className="shop-feature__newline">
          <Link className="shop-feature__link" target={"_blank"} href={glb}>
            <SvgIcon>
              <GroheDownloadIcon/>
            </SvgIcon>
            <span className="shop-feature__link-text">
            <FormattedMessage id="grohe.feature.info.augButton"/>
          </span>
          </Link>
        </div>
      ) : null}
    </div>
  )
};

ShopFeatureDownloads.propTypes = {
  feature: PropTypes.shape(featureInterface)
}

export default ShopFeatureDownloads
